import { defineMessages } from 'react-intl'

const messages = defineMessages({
  insuranceTitle: {
    id: 'X3V8x1wRA2',
    defaultMessage: 'Want to add travel insurance?',
    description: 'Checkout review section title prompting the user to add travel insurance to their booking',
  },
  travelProtectionTitle: {
    id: 'k7OF5eMHH3',
    defaultMessage: 'Want to add travel protection?',
    description: 'Checkout review section title prompting the user to add travel protection to their booking',
  },
})

export const INSURANCE_TITLE_DESCRIPTOR = messages.insuranceTitle
export const TRAVEL_PROTECTION_TITLE_DESCRIPTOR = messages.travelProtectionTitle
